import { create } from "zustand";

type LeaveApplicationType = {
  id: string;
  leaveType: string;
  reason: string;
  startDate: string | Date;
  endDate: string | Date;
  status: string;
  employeeName: string;
  employeeEmail: string;
  createdAt: string | Date;
  attachment: string;
  isPaid: boolean;
} | null;

interface HookProps {
  open: boolean;
  leaveApplication: LeaveApplicationType;
  onOpenChange: (open: boolean) => void;
  setLeaveApplication: (leave: LeaveApplicationType) => void;
}

export const useViewModal = create<HookProps>()((set) => ({
  open: false,
  leaveApplication: null,
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
  setLeaveApplication: (leave) =>
    set(() => ({
      leaveApplication: leave,
    })),
}));
